import classnames from 'classnames'
import React, { FC, PropsWithChildren, useId } from 'react'

import { OptionProp } from '../OptionSelector.constant'

import styles from './option-container.module.scss'
export type OptionContainerProps = {
  srOnly: boolean
  value: string
  displayName?: string
  inputClassName?: string
  labelClassName?: string
  disabled?: boolean
  onChange?: (value: string) => void
  lastChanceSizes?: (string | undefined)[]
} & Pick<OptionProp, 'selectionSetId' | 'isSelected'>

export const OptionContainer: FC<PropsWithChildren<OptionContainerProps>> = ({
  children,
  value,
  displayName,
  isSelected,
  srOnly,
  disabled,
  selectionSetId,
  inputClassName,
  labelClassName,
  onChange,
  lastChanceSizes,
}) => {
  const id = useId()
  return (
    <>
      <input
        data-testid={`option-container_${value}`}
        type="radio"
        id={id}
        className={classnames(styles.input, inputClassName)}
        name={selectionSetId}
        checked={isSelected}
        onChange={() => {
          if (onChange) onChange(value)
        }}
        value={value}
        disabled={disabled}
      />
      <label
        htmlFor={id}
        className={classnames(styles.label, labelClassName, {
          [`${styles.label__leavingSoonOutOfStock}`]: lastChanceSizes?.includes(value),
        })}
      >
        {children}
        {srOnly ? <span className="sr-only">{displayName ?? value}</span> : null}
      </label>
    </>
  )
}
